import React from "react";
import { Card } from "../../../../designSystem/Card";


export function SurveyOuterCard(props:React.PropsWithChildren): JSX.Element {
    return (
        <Card variant="outlined" style={{marginTop:40}} padding="32px">
            {props.children}
        </Card>
    );
}

export function SurveyInnerCard(props:React.PropsWithChildren): JSX.Element {
    return (
        <Card variant="lightGray" noBorder>
            {props.children}
        </Card>
    );
}